// extracted by mini-css-extract-plugin
export default {"co-branding-banner":"Mbo8nI","coBrandingBanner":"Mbo8nI","top":"T_ceDZ","logo-wrapper":"TUaUsB","logoWrapper":"TUaUsB","rtl":"uZDewS"};